import { action, observable, computed, toJS } from "mobx";
import { formatDate, formatDateOnly } from "utility.js";

const STORE_EVENTLOGS = "eventlogs";

class EventlogsStore {
  configStore;

  constructor(rawState = {}, configStore) {
    this.configStore = configStore;

    if (rawState.items) {
      this.setItems(rawState.items);
    }
    if (rawState.search) {
      this.setSearch(rawState.search);
    }
  }
  toJS() {
    return {
      items: toJS(this.items),
      search: toJS(this.search),
    };
  }

  @observable items = [];
  @action setItems(value) {
    const bins = {};
    this.configStore.bins.forEach((bin) => {
      bins[bin.id] = bin;
    });

    this.items = value.map((item) => {
      item.UserName = this.configStore.users[item.UserId]
        ? this.configStore.users[item.UserId].Name
        : "";
      item.Timestamp = formatDate(item.Timestamp);

      const details = JSON.parse(item.Details).Details;
      delete item.Details;
      item.Details = [];
      item.FilterField = "";

      const requestdata = details.Request.Data;

      switch (item.Operation) {
        case "CreatePallet":
          item.Operation = "Létrehozás";
          item.Details.push({
            Name: "Faj-fajta",
            Value: this.configStore.items[requestdata.ItemId],
          });
          requestdata.CustomItem &&
            item.Details.push({
              Name: "Egyéb fajta",
              Value: requestdata.CustomItem,
            });
          item.Details.push({ Name: "Sorszám", Value: requestdata.LotNo });
          requestdata.SealNum &&
            item.Details.push({
              Name: "Fémzárszám",
              Value: requestdata.SealNum,
            });
          item.Details.push({
            Name: "Tisztítási fok",
            Value: this.configStore.cleaningRates[requestdata.CleaningRate],
          });
          item.Details.push({
            Name: "Gép",
            Value: this.configStore.machines[requestdata.MachineId].Name,
          });
          item.Details.push({
            Name: "Tisztítás sorszáma",
            Value: requestdata.CleaningCount,
          });
          item.Details.push({
            Name: "Mennyiség",
            Value:
              (requestdata.BagType === "BigBag"
                ? requestdata.Quantity
                : requestdata.BagCount + " x " + requestdata.Quantity) + " kg",
          });
          requestdata.Dressing &&
            item.Details.push({
              Name: "Csávázószer",
              Value: requestdata.Dressing,
            });
          item.Details.push({
            Name: "Beszállító",
            Value: this.configStore.suppliers[parseInt(requestdata.SupplierId)],
          });
          requestdata.CustomSupplier &&
            item.Details.push({
              Name: "Egyedi beszállító",
              Value: requestdata.CustomSupplier,
            });
          break;

        case "ModifyPallet":
          item.Operation = "Módosítás";
          item.Details.push({
            Name: "Faj-fajta",
            Value: this.configStore.items[requestdata.ItemId],
          });
          requestdata.CustomItem &&
            item.Details.push({
              Name: "Egyéb fajta",
              Value: requestdata.CustomItem,
            });
          item.Details.push({ Name: "Sorszám", Value: requestdata.LotNo });
          requestdata.SealNum &&
            item.Details.push({
              Name: "Fémzárszám",
              Value: requestdata.SealNum,
            });
          item.Details.push({
            Name: "Tisztítási fok",
            Value: this.configStore.cleaningRates[requestdata.CleaningRate],
          });
          item.Details.push({
            Name: "Gép",
            Value: this.configStore.machines[requestdata.MachineId].Name,
          });
          item.Details.push({
            Name: "Tisztítás sorszáma",
            Value: requestdata.CleaningCount,
          });
          item.Details.push({
            Name: "Mennyiség",
            Value:
              (requestdata.BagType === "BigBag"
                ? requestdata.Quantity
                : requestdata.BagCount + " x " + requestdata.Quantity) + " kg",
          });
          requestdata.Dressing &&
            item.Details.push({
              Name: "Csávázószer",
              Value: requestdata.Dressing,
            });
          item.Details.push({
            Name: "Beszállító",
            Value: this.configStore.suppliers[parseInt(requestdata.SupplierId)],
          });
          requestdata.CustomSupplier &&
            item.Details.push({
              Name: "Egyedi beszállító",
              Value: requestdata.CustomSupplier,
            });
          break;

        case "SetPalletProperty":
          item.Operation = "Webes módosítás";
          item.Details.push({ Name: "Azonosító", Value: requestdata.PalletId });
          item.Details.push({
            Name: "Faj-fajta",
            Value: this.configStore.items[item.Pallet.ItemId],
          });
          item.Details.push({ Name: "Sorszám", Value: item.Pallet.LotNo });
          item.Pallet.SealNum &&
            item.Details.push({
              Name: "Fémzárszám",
              Value: item.Pallet.SealNum,
            });
          item.Details.push({
            Name: "Tisztítási fok",
            Value: this.configStore.cleaningRates[item.Pallet.CleaningRate],
          });
          item.Details.push({
            Name: "Gép",
            Value: this.configStore.machines[item.Pallet.MachineId]
              ? this.configStore.machines[item.Pallet.MachineId].Name
              : "-",
          });
          item.Details.push({
            Name: "Tisztítás sorszáma",
            Value: item.Pallet.CleaningCount,
          });
          item.Details.push({
            Name: "Mennyiség",
            Value:
              (item.Pallet.BagType === "BigBag"
                ? item.Pallet.Quantity
                : item.Pallet.BagCount + " x " + item.Pallet.Quantity) + " kg",
          });
          item.Pallet.Dressing &&
            item.Details.push({
              Name: "Csávázószer",
              Value: item.Pallet.Dressing,
            });
          item.Details.push({
            Name: "Beszállító",
            Value: this.configStore.suppliers[parseInt(item.Pallet.SupplierId)],
          });
          requestdata.CustomSupplier &&
            item.Details.push({
              Name: "Egyedi beszállító",
              Value: item.Pallet.CustomSupplier,
            });
          break;

        case "DeletePallet":
          item.Operation = "Törlés";
          item.Details.push({ Name: "Azonosító", Value: requestdata.PalletId });
          item.Details.push({
            Name: "Faj-fajta",
            Value: this.configStore.items[item.Pallet.ItemId],
          });
          item.Details.push({ Name: "Sorszám", Value: item.Pallet.LotNo });
          item.Pallet.SealNum &&
            item.Details.push({
              Name: "Fémzárszám",
              Value: item.Pallet.SealNum,
            });
          item.Details.push({
            Name: "Tisztítási fok",
            Value: this.configStore.cleaningRates[item.Pallet.CleaningRate],
          });
          item.Details.push({
            Name: "Gép",
            Value: this.configStore.machines[item.Pallet.MachineId].Name,
          });
          item.Details.push({
            Name: "Tisztítás sorszáma",
            Value: item.Pallet.CleaningCount,
          });
          item.Details.push({
            Name: "Mennyiség",
            Value:
              (item.Pallet.BagType === "BigBag"
                ? item.Pallet.Quantity
                : item.Pallet.BagCount + " x " + item.Pallet.Quantity) + " kg",
          });
          item.Pallet.Dressing &&
            item.Details.push({
              Name: "Csávázószer",
              Value: item.Pallet.Dressing,
            });
          item.Details.push({
            Name: "Beszállító",
            Value: this.configStore.suppliers[parseInt(item.Pallet.SupplierId)],
          });
          requestdata.CustomSupplier &&
            item.Details.push({
              Name: "Egyedi beszállító",
              Value: item.Pallet.CustomSupplier,
            });
          break;

        case "ProcessPallet":
          item.Operation = "Feldolgozás";
          item.Details.push({ Name: "Azonosító", Value: requestdata.PalletId });
          item.Details.push({
            Name: "Faj-fajta",
            Value: this.configStore.items[item.Pallet.ItemId],
          });
          item.Details.push({ Name: "Sorszám", Value: item.Pallet.LotNo });
          item.Pallet.SealNum &&
            item.Details.push({
              Name: "Fémzárszám",
              Value: item.Pallet.SealNum,
            });
          item.Details.push({
            Name: "Tisztítási fok",
            Value: this.configStore.cleaningRates[item.Pallet.CleaningRate],
          });
          item.Details.push({
            Name: "Gép",
            Value: this.configStore.machines[item.Pallet.MachineId].Name,
          });
          item.Details.push({
            Name: "Tisztítás sorszáma",
            Value: item.Pallet.CleaningCount,
          });
          item.Details.push({
            Name: "Mennyiség",
            Value:
              (item.Pallet.BagType === "BigBag"
                ? item.Pallet.Quantity
                : item.Pallet.BagCount + " x " + item.Pallet.Quantity) + " kg",
          });
          item.Pallet.Dressing &&
            item.Details.push({
              Name: "Csávázószer",
              Value: item.Pallet.Dressing,
            });
          item.Details.push({
            Name: "Beszállító",
            Value: this.configStore.suppliers[parseInt(item.Pallet.SupplierId)],
          });
          requestdata.CustomSupplier &&
            item.Details.push({
              Name: "Egyedi beszállító",
              Value: item.Pallet.CustomSupplier,
            });
          break;

        case "ReprocessPallet":
          item.Operation = "Újradolgozás";
          item.Details.push({ Name: "Azonosító", Value: requestdata.PalletId });
          item.Details.push({
            Name: "Faj-fajta",
            Value: this.configStore.items[item.Pallet.ItemId],
          });
          item.Details.push({ Name: "Sorszám", Value: item.Pallet.LotNo });
          item.Pallet.SealNum &&
            item.Details.push({
              Name: "Fémzárszám",
              Value: item.Pallet.SealNum,
            });
          item.Details.push({
            Name: "Tisztítási fok",
            Value: this.configStore.cleaningRates[item.Pallet.CleaningRate],
          });
          item.Details.push({
            Name: "Gép",
            Value: this.configStore.machines[item.Pallet.MachineId].Name,
          });
          item.Details.push({
            Name: "Tisztítás sorszáma",
            Value: item.Pallet.CleaningCount,
          });
          item.Details.push({
            Name: "Mennyiség",
            Value:
              (item.Pallet.BagType === "BigBag"
                ? item.Pallet.Quantity
                : item.Pallet.BagCount + " x " + item.Pallet.Quantity) + " kg",
          });
          item.Pallet.Dressing &&
            item.Details.push({
              Name: "Csávázószer",
              Value: item.Pallet.Dressing,
            });
          item.Details.push({
            Name: "Beszállító",
            Value: this.configStore.suppliers[parseInt(item.Pallet.SupplierId)],
          });
          requestdata.CustomSupplier &&
            item.Details.push({
              Name: "Egyedi beszállító",
              Value: item.Pallet.CustomSupplier,
            });
          break;

        case "MixturePallet":
          item.Operation = "Keverékhez felhasználás";
          item.Details.push({ Name: "Azonosító", Value: requestdata.PalletId });
          item.Details.push({
            Name: "Faj-fajta",
            Value: this.configStore.items[item.Pallet.ItemId],
          });
          item.Details.push({ Name: "Sorszám", Value: item.Pallet.LotNo });
          item.Pallet.SealNum &&
            item.Details.push({
              Name: "Fémzárszám",
              Value: item.Pallet.SealNum,
            });
          item.Details.push({
            Name: "Tisztítási fok",
            Value: this.configStore.cleaningRates[item.Pallet.CleaningRate],
          });
          item.Details.push({
            Name: "Gép",
            Value: this.configStore.machines[item.Pallet.MachineId].Name,
          });
          item.Details.push({
            Name: "Tisztítás sorszáma",
            Value: item.Pallet.CleaningCount,
          });
          item.Details.push({
            Name: "Felhasznált mennyiség",
            Value:
              (requestdata.BagType === "BigBag"
                ? requestdata.Quantity
                : requestdata.BagCount + " x " + requestdata.Quantity) + " kg",
          });
          item.Details.push({
            Name: "Raklap mennyiség",
            Value:
              item.Pallet.Status !== 0
                ? "feldolgozva"
                : (item.Pallet.BagType === "BigBag"
                    ? item.Pallet.Quantity
                    : item.Pallet.BagCount + " x " + item.Pallet.Quantity) +
                  " kg",
          });
          item.Pallet.Dressing &&
            item.Details.push({
              Name: "Csávázószer",
              Value: item.Pallet.Dressing,
            });
          item.Details.push({
            Name: "Beszállító",
            Value: this.configStore.suppliers[parseInt(item.Pallet.SupplierId)],
          });
          requestdata.CustomSupplier &&
            item.Details.push({
              Name: "Egyedi beszállító",
              Value: item.Pallet.CustomSupplier,
            });
          break;

        case "SellPallet":
          item.Operation = "Értékesítés";
          item.Details.push({ Name: "Azonosító", Value: requestdata.PalletId });
          item.Details.push({
            Name: "Faj-fajta",
            Value: this.configStore.items[item.Pallet.ItemId],
          });
          item.Details.push({ Name: "Sorszám", Value: item.Pallet.LotNo });
          item.Pallet.SealNum &&
            item.Details.push({
              Name: "Fémzárszám",
              Value: item.Pallet.SealNum,
            });
          item.Details.push({
            Name: "Tisztítási fok",
            Value: this.configStore.cleaningRates[item.Pallet.CleaningRate],
          });
          item.Details.push({
            Name: "Gép",
            Value: this.configStore.machines[item.Pallet.MachineId].Name,
          });
          item.Details.push({
            Name: "Tisztítás sorszáma",
            Value: item.Pallet.CleaningCount,
          });
          item.Details.push({
            Name: "Mennyiség",
            Value:
              (item.Pallet.BagType === "BigBag"
                ? item.Pallet.Quantity
                : item.Pallet.BagCount + " x " + item.Pallet.Quantity) + " kg",
          });
          item.Pallet.Dressing &&
            item.Details.push({
              Name: "Csávázószer",
              Value: item.Pallet.Dressing,
            });
          item.Details.push({
            Name: "Beszállító",
            Value: this.configStore.suppliers[parseInt(item.Pallet.SupplierId)],
          });
          requestdata.CustomSupplier &&
            item.Details.push({
              Name: "Egyedi beszállító",
              Value: item.Pallet.CustomSupplier,
            });
          break;

        case "PlacePallet":
          item.Operation = "Lerakás";
          item.Details.push({ Name: "Azonosító", Value: requestdata.PalletId });
          item.Details.push({
            Name: "Faj-fajta",
            Value: this.configStore.items[item.Pallet.ItemId],
          });
          item.Pallet.CustomItem &&
            item.Details.push({
              Name: "Egyéb fajta",
              Value: item.Pallet.CustomItem,
            });
          item.Details.push({ Name: "Sorszám", Value: item.Pallet.LotNo });
          item.Pallet.SealNum &&
            item.Details.push({
              Name: "Fémzárszám",
              Value: item.Pallet.SealNum,
            });
          item.Details.push({
            Name: "Tárhely",
            Value: bins[parseInt(requestdata.BinId)].name,
          });
          item.Details.push({
            Name: "Tisztítási fok",
            Value: this.configStore.cleaningRates[item.Pallet.CleaningRate],
          });
          item.Details.push({
            Name: "Gép",
            Value: this.configStore.machines[item.Pallet.MachineId].Name,
          });
          item.Details.push({
            Name: "Tisztítás sorszáma",
            Value: item.Pallet.CleaningCount,
          });
          item.Details.push({
            Name: "Mennyiség",
            Value:
              (item.Pallet.BagType === "BigBag"
                ? item.Pallet.Quantity
                : item.Pallet.BagCount + " x " + item.Pallet.Quantity) + " kg",
          });
          item.Pallet.Dressing &&
            item.Details.push({
              Name: "Csávázószer",
              Value: item.Pallet.Dressing,
            });
          item.Details.push({
            Name: "Beszállító",
            Value: this.configStore.suppliers[parseInt(item.Pallet.SupplierId)],
          });
          requestdata.CustomSupplier &&
            item.Details.push({
              Name: "Egyedi beszállító",
              Value: item.Pallet.CustomSupplier,
            });
          break;

        case "AutoPlacePallet":
          item.Operation = "Mozgatás (folyosón)";
          item.Details.push({
            Name: "Azonosító",
            Value: requestdata.Pallet.Id,
          });
          item.Details.push({
            Name: "Faj-fajta",
            Value: this.configStore.items[item.Pallet.ItemId],
          });
          requestdata.Pallet.CustomItem &&
            item.Details.push({
              Name: "Egyéb fajta",
              Value: requestdata.Pallet.CustomItem,
            });
          item.Details.push({ Name: "Sorszám", Value: item.Pallet.LotNo });
          item.Pallet.SealNum &&
            item.Details.push({
              Name: "Fémzárszám",
              Value: item.Pallet.SealNum,
            });
          item.Details.push({
            Name: "Tárhely",
            Value: bins[parseInt(requestdata.BinId)].name,
          });
          item.Details.push({
            Name: "Tisztítási fok",
            Value: this.configStore.cleaningRates[item.Pallet.CleaningRate],
          });
          item.Details.push({
            Name: "Gép",
            Value: this.configStore.machines[item.Pallet.MachineId].Name,
          });
          item.Details.push({
            Name: "Tisztítás sorszáma",
            Value: item.Pallet.CleaningCount,
          });
          item.Details.push({
            Name: "Mennyiség",
            Value:
              (item.Pallet.BagType === "BigBag"
                ? item.Pallet.Quantity
                : item.Pallet.BagCount + " x " + item.Pallet.Quantity) + " kg",
          });
          item.Pallet.Dressing &&
            item.Details.push({
              Name: "Csávázószer",
              Value: item.Pallet.Dressing,
            });
          item.Details.push({
            Name: "Beszállító",
            Value: this.configStore.suppliers[parseInt(item.Pallet.SupplierId)],
          });
          requestdata.CustomSupplier &&
            item.Details.push({
              Name: "Egyedi beszállító",
              Value: item.Pallet.CustomSupplier,
            });
          break;
      }

      details.Response &&
        details.Response.Error &&
        item.Details.push({ Name: "Eredmény", Value: "Sikertelen művelet." });

      item.FilterField = (
        item.Timestamp +
        " " +
        item.UserName +
        " " +
        item.Operation +
        " " +
        item.Details.reduce(function (acc, curr) {
          return acc + " " + curr.Value;
        }, "")
      ).toLowerCase();

      return item;
    });
  }

  @observable from;
  @action setFrom(value) {
    this.from = value;
  }
  @computed get fromFormatted() {
    return formatDateOnly(this.from);
  }

  @observable to;
  @action setTo(value) {
    this.to = value;
  }
  @computed get toFormatted() {
    return formatDateOnly(this.to);
  }

  @observable logCount = 100;
  @action increaseLogCount() {
    this.logCount += 100;
  }

  @observable search = "";
  @action setSearch(value) {
    this.search = value;
  }

  @computed get filteredItems() {
    if (!this.search) {
      return this.items;
    }
    return observable(
      this.items.filter((item) => {
        const searches = this.search.split(" ");
        for (let i = 0; i < searches.length; i++) {
          const s = searches[i].toLowerCase();
          //console.log(s, item.FilterField)
          if (item.FilterField.indexOf(s) === -1) {
            return false;
          }
        }
        return true;

        for (let fieldValue of Object.values(item)) {
          if (("" + fieldValue).indexOf(this.search) > -1) {
            return true;
          }
        }
        return false;
      })
    );
  }

  @computed get shownItems() {
    return this.filteredItems.slice(0, this.logCount);
  }

  @observable eventlogs;
  @action setEventlogs(value) {
    this.eventlogs = value;
  }
}

export { EventlogsStore, STORE_EVENTLOGS };
